import type { Issuer } from "./open-id-connect";
import OpenIdConnectService from "./open-id-connect";

export default class ProSanteConnect extends OpenIdConnectService {
  featureFlag = "enabling_auth_by_psc";
  imageUrl = "/assets/ui-images/pro-sante-connect-logo.svg";
  issuer: Issuer = "pro-sante-connect";
  label = "Pro Santé Connect";
  override route = "login.pro-sante-connect";
}
